var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.6,256.9c-9.8-4.7-19.9-8.7-30.1-12.1C370.6,220,392,180.5,392,136C392,61,331,0,256,0S120,61,120,136 c0,44.5,21.5,84.1,54.6,108.9c-30.4,10-58.9,25.6-83.8,46.1c-45.7,37.6-77.5,90.1-89.5,147.7c-3.8,18.1,0.7,36.6,12.4,50.9 c11.6,14.2,28.7,22.4,47,22.4H307c11,0,20-9,20-20s-9-20-20-20H60.7c-8.5,0-13.7-4.8-16-7.6c-4-4.9-5.5-11.3-4.2-17.5 c20.8-99.7,108.7-172.5,210.2-175c1.8,0.1,3.5,0.1,5.3,0.1c1.8,0,3.6,0,5.4-0.1c31.1,0.7,61,7.8,89,21.1c10,4.7,21.9,0.5,26.6-9.5 C381.8,273.6,377.5,261.7,367.6,256.9z M260.9,231.9c-1.6,0-3.2,0-4.9,0c-1.6,0-3.2,0-4.8,0c-50.7-2.5-91.2-44.6-91.2-95.9 c0-52.9,43.1-96,96-96s96,43.1,96,96C352,187.3,311.6,229.3,260.9,231.9z",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M492,397h-55v-55c0-11-9-20-20-20s-20,9-20,20v55h-55c-11,0-20,9-20,20s9,20,20,20h55v55c0,11,9,20,20,20s20-9,20-20v-55 h55c11,0,20-9,20-20S503,397,492,397z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.efa8a898.svg";
export { ForwardRef as ReactComponent };